import React, { useState, useEffect, useRef } from "react";
import {
  Edit2,
  Wallet,
  Receipt,
  FileText,
  Calendar,
  TrendingUp,
  TrendingDown,
  Users,
  MapPin,
  Trash2,
  PlusCircle,
  Gift,
  ChevronRight,
  ChevronLeft,
  Building,
  Hammer,
  DollarSign,
} from "lucide-react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { MyDomain } from "../../../App";
import BossCreateDayWork from "../BossDailyWorkComps/BossCreateDailyWork";
import BossCreateExpenses from "../BossStatisticComps/BossCreateExpenses";
import BossUpdateExpensesModal from "../BossStatisticComps/BossUpdateExpensesModal";
import BossUpdateEmployeeModal from "../BossEmployeeComps/BossUpdateEmployeeModal";
import BossUpdatePlacesModal from "../BossPlacesComps/BossUpdatePlacesModal";
import BossCreateMonthlySalary from "../BossMonthlySalaryComps/BossCreateMonthlySalary";
import BossCreatePlacesGloballyPaidModal from "../BossPlacesComps/BossCreatePlacesGloballyPaidModal";
import BossStatisticPlacesModalAddExtraProfit from "./BossStatisticPlacesModalAddExtraProfit";
import BossCreateInvoice from "../BossInvoicesComps/BossCreateInvoice";
import BossPlaceInvoicesModal from "./BossPlaceInvoicesModal";
import { useTranslation } from "react-i18next";

/* ─── Styles ──────────────────────────────────────────────────────────── */
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=JetBrains+Mono:wght@500;700&display=swap');

  .spd * { box-sizing: border-box; }
  .spd {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: #F0F2F7;
    min-height: 100vh;
    color: #111827;
  }

  .spd-header {
    background: #fff;
    border-bottom: 1px solid #E5E7EB;
    padding: 16px 18px 14px;
    position: sticky; top: 0; z-index: 20;
  }
  .spd-topbar {
    display: flex; align-items: center; gap: 12px;
    margin-bottom: 14px;
  }
  .spd-back {
    width: 36px; height: 36px; border-radius: 10px;
    border: 1px solid #E5E7EB; background: #F9FAFB;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #374151; transition: all 0.15s; flex-shrink: 0;
  }
  .spd-back:hover { border-color: #F59E0B; color: #D97706; background: #FFFBEB; }

  .spd-place-ico {
    width: 44px; height: 44px; border-radius: 13px;
    background: linear-gradient(135deg, #FCD34D, #F59E0B);
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 3px 10px rgba(245,158,11,0.3);
  }
  .spd-place-name {
    font-size: 17px; font-weight: 800; color: #111827;
    letter-spacing: -0.02em; line-height: 1.2;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .spd-place-sub { font-size: 11px; color: #9CA3AF; font-weight: 500; margin-top: 2px; }

  /* 5 action buttons */
  .spd-actions { display: grid; grid-template-columns: repeat(5,1fr); gap: 6px; }
  .spd-action {
    display: flex; flex-direction: column; align-items: center; gap: 4px;
    padding: 9px 4px; border-radius: 11px; border: none;
    cursor: pointer; transition: all 0.15s; font-family: 'Plus Jakarta Sans', sans-serif;
    position: relative;
  }
  .spd-action span { font-size: 10px; font-weight: 700; color: #fff; }
  .spd-action.edit    { background: #3B82F6; }
  .spd-action.salary  { background: #7C3AED; }
  .spd-action.expense { background: #F59E0B; }
  .spd-action.invoice { background: #8B5CF6; }
  .spd-action.invoices{ background: #6d28d9; }
  .spd-action:hover { filter: brightness(1.08); transform: translateY(-1px); }

  .spd-body { padding: 14px 16px 80px; }

  .spd-sec-title {
    font-size: 11px; font-weight: 700; color: #6B7280;
    letter-spacing: 0.1em; text-transform: uppercase;
    margin-bottom: 10px;
  }

  .spd-month-section { margin-bottom: 16px; }
  .spd-month-row { display: flex; align-items: center; gap: 6px; }
  .spd-month-arrow {
    width: 30px; height: 30px; border-radius: 8px;
    border: 1px solid #E5E7EB; background: #fff;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #6B7280; transition: all 0.15s; flex-shrink: 0;
  }
  .spd-month-arrow:hover { border-color: #F59E0B; color: #D97706; background: #FFFBEB; }
  .spd-month-scroll-wrap { flex: 1; overflow: hidden; position: relative; }
  .spd-month-scroll-wrap::before,
  .spd-month-scroll-wrap::after {
    content: ''; position: absolute; top: 0; bottom: 0; width: 18px; z-index: 2; pointer-events: none;
  }
  .spd-month-scroll-wrap::before { left:0; background: linear-gradient(to right, #F0F2F7, transparent); }
  .spd-month-scroll-wrap::after  { right:0; background: linear-gradient(to left,  #F0F2F7, transparent); }
  .spd-month-track {
    display: flex; gap: 6px; overflow-x: auto; scroll-behavior: smooth;
    padding: 2px 4px; scrollbar-width: none;
  }
  .spd-month-track::-webkit-scrollbar { display: none; }
  .spd-month-btn {
    flex-shrink: 0; width: 62px; padding: 7px 5px;
    border-radius: 10px; border: 1.5px solid #E5E7EB;
    background: #fff; cursor: pointer; text-align: center;
    transition: all 0.18s ease;
  }
  .spd-month-btn:hover { border-color: #FCD34D; background: #FFFBEB; }
  .spd-month-btn.active {
    background: #F59E0B; border-color: #F59E0B;
    box-shadow: 0 3px 10px rgba(245,158,11,0.35);
    transform: scale(1.06);
  }
  .spd-month-name { font-size: 13px; font-weight: 700; display: block; color: #374151; line-height: 1.2; }
  .spd-month-btn.active .spd-month-name { color: #fff; }
  .spd-month-year { font-size: 9px; font-weight: 500; color: #9CA3AF; font-family: 'JetBrains Mono', monospace; display: block; margin-top: 2px; }
  .spd-month-btn.active .spd-month-year { color: rgba(255,255,255,0.8); }

  .spd-stats { display: flex; gap: 8px; margin-bottom: 16px; }
  .spd-stat {
    flex: 1; background: #fff; border-radius: 12px;
    border: 1px solid #E5E7EB; border-left: 3px solid transparent;
    padding: 10px 12px; display: flex; align-items: center; gap: 10px;
  }
  .spd-stat.blue  { border-left-color: #3B82F6; }
  .spd-stat.purple{ border-left-color: #7C3AED; }
  .spd-stat-ico {
    width: 34px; height: 34px; border-radius: 9px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .spd-stat.blue   .spd-stat-ico { background: #EFF6FF; }
  .spd-stat.purple .spd-stat-ico { background: #EDE9FE; }
  .spd-stat-val { font-size: 20px; font-weight: 800; color: #111827; letter-spacing: -0.03em; line-height: 1; }
  .spd-stat-lbl { font-size: 10px; color: #9CA3AF; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; margin-top: 2px; }

  .spd-finance-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 10px;
  }
  .spd-finance-badge {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px; font-weight: 700; color: #D97706;
    background: #FEF3C7; border: 1px solid #FDE68A;
    border-radius: 7px; padding: 3px 9px;
  }

  .spd-fcard {
    background: #fff; border-radius: 13px;
    border: 1px solid #E5E7EB;
    padding: 12px 14px; margin-bottom: 10px;
  }
  .spd-fcard-row { display: flex; align-items: center; gap: 10px; }
  .spd-fcard-ico {
    width: 34px; height: 34px; border-radius: 9px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .spd-fcard-label { flex: 1; font-size: 13px; font-weight: 600; color: #374151; }
  .spd-fcard-sub { font-size: 10px; color: #9CA3AF; margin-top: 1px; }
  .spd-fcard-amount { font-family: 'JetBrains Mono', monospace; font-size: 15px; font-weight: 700; }
  .spd-fcard-divider { height: 1px; background: #F3F4F6; margin: 10px 0; }

  .spd-list-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 8px;
  }
  .spd-list-lbl { font-size: 10px; font-weight: 700; color: #6B7280; text-transform: uppercase; letter-spacing: 0.07em; }
  .spd-add-btn {
    display: flex; align-items: center; gap: 5px;
    background: #F0FDF4; border: 1px solid #86EFAC;
    color: #059669; font-size: 11px; font-weight: 700;
    padding: 4px 10px; border-radius: 7px; cursor: pointer;
    transition: all 0.15s; font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .spd-add-btn:hover { background: #DCFCE7; border-color: #059669; }

  .spd-list-item { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
  .spd-list-item-inner {
    flex: 1; display: flex; align-items: center; justify-content: space-between;
    background: #F9FAFB; border: 1px solid #E5E7EB;
    border-radius: 9px; padding: 8px 10px; min-width: 0;
  }
  .spd-list-item-left { display: flex; align-items: center; gap: 8px; min-width: 0; }
  .spd-list-item-ico {
    width: 26px; height: 26px; border-radius: 7px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .spd-list-item-title { font-size: 12px; font-weight: 600; color: #374151; }
  .spd-list-item-sub { font-size: 10px; color: #9CA3AF; margin-top: 1px; }
  .spd-list-item-amt { font-family: 'JetBrains Mono', monospace; font-size: 12px; font-weight: 700; flex-shrink: 0; }
  .spd-del-btn {
    width: 28px; height: 28px; border-radius: 7px; border: none;
    background: #FEE2E2; display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: background 0.15s; flex-shrink: 0;
  }
  .spd-del-btn:hover { background: #FECACA; }

  .spd-empty-list {
    display: flex; flex-direction: column; align-items: center;
    padding: 20px 16px; gap: 5px; text-align: center;
  }
  .spd-empty-list p { font-size: 12px; color: #9CA3AF; font-weight: 500; }

  .spd-exp-type-row {
    display: flex; align-items: center; justify-content: space-between;
    padding: 6px 0; border-bottom: 1px solid #F9FAFB;
  }
  .spd-exp-type-row:last-child { border-bottom: none; }
  .spd-exp-type-left { display: flex; align-items: center; gap: 8px; }
  .spd-exp-type-ico { width: 26px; height: 26px; border-radius: 7px; display: flex; align-items: center; justify-content: center; }
  .spd-exp-badge { font-size: 9px; font-weight: 700; background: #F3F4F6; color: #6B7280; border-radius: 4px; padding: 1px 5px; }

  .spd-pair {
    display: grid; grid-template-columns: 1fr; gap: 10px; margin-bottom: 10px;
  }
  .spd-pair > .spd-fcard { margin-bottom: 0; }
  @media (min-width: 768px) { .spd-pair { grid-template-columns: 1fr 1fr; align-items: start; } }

  .spd-net-card {
    border-radius: 13px; padding: 14px;
    border: 2px solid transparent; margin-bottom: 10px;
  }
  .spd-net-card.positive { background: #F0FDF4; border-color: #86EFAC; }
  .spd-net-card.negative { background: #FFF1F2; border-color: #FECACA; }

  .spd-days-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 10px;
  }
  .spd-days-badge {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px; font-weight: 600; color: #D97706;
    background: #FEF3C7; border: 1px solid #FDE68A;
    border-radius: 6px; padding: 3px 8px;
  }

  .spd-day-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; }
  @media (min-width: 480px) { .spd-day-grid { grid-template-columns: repeat(3, 1fr); } }
  @media (min-width: 768px) { .spd-day-grid { grid-template-columns: repeat(4, 1fr); } }

  .spd-day {
    background: #fff; border: 1.5px solid #E5E7EB;
    border-radius: 12px; padding: 10px; min-height: 130px;
    cursor: pointer; position: relative; transition: all 0.18s ease;
    display: flex; flex-direction: column; text-align: left;
  }
  .spd-day:hover { box-shadow: 0 4px 14px rgba(0,0,0,0.09); transform: translateY(-2px); }
  .spd-day.worked { border-color: #FCD34D; background: #FFFBEB; }
  .spd-day.today  { box-shadow: 0 0 0 2px rgba(59,130,246,0.25); border-color: #93C5FD; }
  .spd-day.worked.today { border-color: #F59E0B; }

  .spd-day-top {
    display: flex; justify-content: space-between; align-items: flex-start;
    margin-bottom: 7px; padding-bottom: 7px; border-bottom: 1px solid #F3F4F6;
  }
  .spd-day.worked .spd-day-top { border-bottom-color: #FDE68A; }
  .spd-day-num { font-size: 17px; font-weight: 800; color: #D1D5DB; line-height: 1; }
  .spd-day.worked .spd-day-num { color: #D97706; }
  .spd-day.today  .spd-day-num { color: #3B82F6; }
  .spd-day-name { font-size: 8px; font-weight: 700; color: #9CA3AF; text-transform: uppercase; letter-spacing: 0.07em; }
  .spd-day.worked .spd-day-name { color: #92400E; }

  .spd-day-body { flex: 1; display: flex; flex-direction: column; gap: 4px; }

  .spd-day-badges { display: flex; gap: 4px; flex-wrap: wrap; margin-bottom: 4px; }
  .spd-badge { display: inline-flex; align-items: center; gap: 3px; font-size: 9px; font-weight: 700; padding: 2px 5px; border-radius: 4px; }
  .spd-badge.emp    { background: #EDE9FE; color: #7C3AED; }
  .spd-badge.salary { background: #FEE2E2; color: #DC2626; }
  .spd-badge.rev    { background: #D1FAE5; color: #059669; }

  .spd-day-emp {
    background: #fff; border: 1px solid #F3F4F6;
    border-radius: 7px; padding: 5px 7px;
    display: flex; align-items: flex-start; gap: 5px;
  }
  .spd-day.worked .spd-day-emp { background: #FFFBEB; border-color: #FDE68A; }
  .spd-day-emp-name { font-size: 9px; font-weight: 600; color: #374151; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .spd-day-emp-sal  { font-size: 9px; font-weight: 700; color: #DC2626; }
  .spd-day-emp-rev  { font-size: 9px; font-weight: 700; color: #059669; }
  .spd-day-emp-mgr  { font-size: 8px; color: #9CA3AF; font-style: italic; }

  .spd-day-empty {
    flex: 1; display: flex; flex-direction: column;
    align-items: center; justify-content: center; gap: 3px;
  }
  .spd-day-note-dot {
    position: absolute; top: 6px; right: 6px;
    width: 14px; height: 14px; border-radius: 4px;
    background: #FEF9C3; border: 1px solid #FDE68A;
    display: flex; align-items: center; justify-content: center;
  }

  .spd-loading {
    display: flex; align-items: center; justify-content: center;
    height: 100vh; background: #F0F2F7;
  }
  .spd-spinner {
    width: 36px; height: 36px;
    border: 3px solid #E5E7EB; border-top-color: #F59E0B;
    border-radius: 50%; animation: spd-spin 0.75s linear infinite;
  }
  @keyframes spd-spin { to { transform: rotate(360deg); } }

  .spd-hide-scroll::-webkit-scrollbar { display: none; }
  .spd-hide-scroll { -ms-overflow-style: none; scrollbar-width: none; }
`;

export default function BossStatisticPlacesData() {
  const { t } = useTranslation();
  const history = useHistory();
  const monthTrackRef = useRef(null);

  const [choosedPlace, setChoosedPlace] = useState(null);
  const [choosedMonth, setChoosedMonth] = useState(null);
  const [allData, setAllData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [existingEmployees, setExistingEmployees] = useState([]);
  const [showCreateExpenseModal, setShowCreateExpenseModal] = useState(false);
  const [showUpdateExpenseModal, setShowUpdateExpenseModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [showUpdateEmployeeModal, setShowUpdateEmployeeModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showUpdatePlaceModal, setShowUpdatePlaceModal] = useState(false);
  const [showMonthlySalaryModal, setShowMonthlySalaryModal] = useState(false);
  const [showGlobalPaymentModal, setShowGlobalPaymentModal] = useState(false);
  const [showExtraProfitModal, setShowExtraProfitModal] = useState(false);
  const [createInvoiceVisible, setCreateInvoiceVisible] = useState(false);

  // ── NEW: place invoices ──
  const [showPlaceInvoicesModal, setShowPlaceInvoicesModal] = useState(false);
  const [placeInvoices, setPlaceInvoices] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({ visible: false, message: "", onConfirm: null });
  const [toast, setToast] = useState({ visible: false, message: "", type: "success" });

  useEffect(() => {
    const place = localStorage.getItem("choosedPlace");
    const month =
      localStorage.getItem("choosedMonth") || moment().format("MM-YYYY");
    const data = localStorage.getItem("allData");
    const user = localStorage.getItem("user");
    if (place) setChoosedPlace(JSON.parse(place));
    if (data) setAllData(JSON.parse(data));
    if (user) setUserData(JSON.parse(user));
    setChoosedMonth(month);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (choosedMonth) localStorage.setItem("choosedMonth", choosedMonth);
  }, [choosedMonth]);

  // Scroll selected month into view
  useEffect(() => {
    if (!choosedMonth || !monthTrackRef.current) return;
    const idx = monthList.findIndex((m) => m === choosedMonth);
    if (idx < 0) return;
    const btn = monthTrackRef.current.children[idx];
    if (btn)
      btn.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
  }, [choosedMonth]);

  // ── Load invoices linked to this place ──
  useEffect(() => {
    if (!loading && choosedPlace?.id && userData?.id) loadPlaceInvoices();
  }, [loading, choosedPlace?.id, userData?.id]);

  // ── Fetch historical exchange rate for a given currency on a given date ──
  // Handles date formats: DD-MM-YYYY, DD/MM/YYYY, MM/DD/YYYY, YYYY-MM-DD
  // ── Fetch ILS rate for any currency (open.er-api supports ILS) ──
  const getExchangeRate = async (currency, date) => {
    try {
      if (currency === "ILS") return 1;
      // Primary: open.er-api.com — free, no key, supports ILS
      const res = await fetch(`https://open.er-api.com/v6/latest/${currency}`);
      if (res.ok) {
        const d = await res.json();
        if (d?.rates?.ILS && d.rates.ILS > 0) return d.rates.ILS;
      }
      // Fallback: exchangerate.host
      const res2 = await fetch(
        `https://api.exchangerate.host/convert?from=${currency}&to=ILS&amount=1`,
      );
      if (res2.ok) {
        const d2 = await res2.json();
        if (d2?.result && d2.result > 0) return d2.result;
      }
      return null;
    } catch {
      return null;
    }
  };

  const loadPlaceInvoices = async () => {
    if (!userData?.id || !choosedPlace?.id) return;
    try {
      const API = MyDomain.endsWith("/") ? MyDomain.slice(0, -1) : MyDomain;
      const res = await fetch(`${API}/api/email-invoices/${userData.id}`);
      if (res.ok) {
        const d = await res.json();
        const linked = (d.invoices || []).filter(
          (i) => Number(i.placeId) === Number(choosedPlace.id),
        );

        // For every non-ILS invoice, fetch the historical ILS rate on invoice date
        const enriched = await Promise.all(
          linked.map(async (inv) => {
            const currency = inv.currency || "ILS";
            if (currency === "ILS") {
              return {
                ...inv,
                ilsEquivalent: parseFloat(inv.price || 0),
                exchangeRate: 1,
              };
            }
            const rate = await getExchangeRate(currency, inv.date);
            const ilsEquivalent =
              rate != null ? parseFloat(inv.price || 0) * rate : null;
            return { ...inv, ilsEquivalent, exchangeRate: rate };
          }),
        );

        setPlaceInvoices(enriched);
      }
    } catch {}
  };

  const fetchAllData = async () => {
    if (!userData) return;
    try {
      const response = await axios.post(`${MyDomain}Employee/GetAllData`, {
        UserId: userData.id,
      });
      const data = response.data || {};
      setAllData(data);
      localStorage.setItem("allData", JSON.stringify(data));
      if (choosedPlace?.id && data?.myPlaces) {
        const updated = data.myPlaces.find((p) => p.id === choosedPlace.id);
        if (updated) {
          setChoosedPlace(updated);
          localStorage.setItem("choosedPlace", JSON.stringify(updated));
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (loading || !choosedPlace || !allData) {
    return (
      <div className="spd">
        <style>{STYLES}</style>
        <div className="spd-loading">
          <div className="spd-spinner" />
        </div>
      </div>
    );
  }

  const generateMonths = () => {
    const months = [];
    const now = new Date();
    for (let i = 0; i < 12; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      months.push(
        `${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`,
      );
    }
    return months;
  };
  const monthList = generateMonths();

  const scrollMonths = (dir) => {
    if (monthTrackRef.current)
      monthTrackRef.current.scrollBy({ left: dir * 180, behavior: "smooth" });
  };

  const expenseTypes = [
    { id: 1, name: t("materials"), color: "#3B82F6" },
    { id: 2, name: t("equipment"), color: "#8B5CF6" },
    { id: 3, name: t("transportation"), color: "#10B981" },
    { id: 4, name: t("utilities"), color: "#F59E0B" },
    { id: 5, name: t("otherExpense"), color: "#6B7280" },
  ];

  /* ── Filtered data ── */
  const filteredDailyWork = (allData.myDailyWork || []).filter((item) => {
    if (!choosedPlace?.id || !choosedMonth) return false;
    const [, month, year] = item.date.split("-");
    return (
      item.placeId === choosedPlace.id && `${month}-${year}` === choosedMonth
    );
  });
  const filteredExpenses = (allData.myExpenses || []).filter((item) => {
    if (item.placeId !== choosedPlace.id || !item.date?.trim()) return false;
    const parts = item.date.split("-");
    if (parts.length !== 3) return false;
    return `${parts[1]}-${parts[2]}` === choosedMonth;
  });
  const filteredMonthlySalaries = (
    Array.isArray(allData?.myMonthlySalary) ? allData.myMonthlySalary : []
  ).filter((item) => {
    if (item.placeId !== choosedPlace.id || !item.date?.trim()) return false;
    const p = item.date.split("-");
    if (p.length !== 3) return false;
    return `${p[1]}-${p[2]}` === choosedMonth;
  });
  const filteredExtraProfits = (
    Array.isArray(allData?.myPlaceExtraProfit) ? allData.myPlaceExtraProfit : []
  ).filter((item) => {
    if (item.placeId !== choosedPlace.id || !item.date?.trim()) return false;
    const p = item.date.split("-");
    if (p.length !== 3) return false;
    return `${p[1]}-${p[2]}` === choosedMonth;
  });

  const allTimeDailyWork = (allData.myDailyWork || []).filter(
    (i) => i.placeId === choosedPlace?.id,
  );
  const allTimeExpenses = (allData.myExpenses || []).filter(
    (i) => Number(i.placeId) === Number(choosedPlace.id) && i.date?.trim(),
  );
  const allTimeMonthlySalaries = (
    Array.isArray(allData?.myMonthlySalary) ? allData.myMonthlySalary : []
  ).filter(
    (i) => Number(i.placeId) === Number(choosedPlace.id) && i.date?.trim(),
  );

  /* ── Totals ── */
  const totalExpensesAmount = filteredExpenses.reduce(
    (s, e) => s + (parseFloat(e.price) || 0),
    0,
  );
  const totalDailySalaries = filteredDailyWork.reduce(
    (s, i) => s + (parseFloat(i.salary) || 0),
    0,
  );
  const totalMonthlySalaries = filteredMonthlySalaries.reduce((s, item) => {
    const emp = (allData.myEmployees || []).find(
      (e) => e.id === item.employeeId,
    );
    return s + (emp?.monthlySalary || 0);
  }, 0);
  const totalExtraProfit = filteredExtraProfits.reduce(
    (s, i) => s + (parseFloat(i.profit) || 0),
    0,
  );
  const totalSalaries = totalDailySalaries + totalMonthlySalaries;

  const allTimeExpensesAmount = allTimeExpenses.reduce(
    (s, e) => s + (parseFloat(e.price) || 0),
    0,
  );
  const allTimeDailySal = allTimeDailyWork.reduce(
    (s, i) => s + (parseFloat(i.salary) || 0),
    0,
  );
  const allTimeMonthlySal = allTimeMonthlySalaries.reduce((s, item) => {
    const emp = (allData.myEmployees || []).find(
      (e) => e.id === item.employeeId,
    );
    return s + (emp?.monthlySalary || 0);
  }, 0);
  const allTimeTotalSalaries = allTimeDailySal + allTimeMonthlySal;

  const globalPayments = (
    Array.isArray(allData?.myPlacesGloballyPaid)
      ? allData.myPlacesGloballyPaid
      : []
  ).filter((p) => p.placeId === choosedPlace?.id);
  const totalGlobalPaymentsReceived = globalPayments.reduce(
    (s, p) => s + (parseFloat(p.profit) || 0),
    0,
  );
  const totalGlobalProfit = parseFloat(choosedPlace?.profit || 0);

  // ── Invoice costs — sum ILS equivalent for ALL invoices (including converted foreign currency) ──
  // ilsEquivalent is set during loadPlaceInvoices: ILS invoices use face value,
  // foreign invoices use the historical exchange rate on the invoice date.
  // If rate fetch failed (null), we fall back to the face value as a safe default.
  const totalInvoicesCost = placeInvoices.reduce((s, inv) => {
    const ils =
      inv.ilsEquivalent != null
        ? inv.ilsEquivalent
        : parseFloat(inv.price || 0); // fallback if rate lookup failed
    return s + ils;
  }, 0);

  let placeRevenue = 0,
    netProfit = 0;
  if (choosedPlace?.paidWay === 2) {
    placeRevenue = filteredDailyWork.reduce(
      (s, i) => s + (parseFloat(i.placeDailySalary) || 0),
      0,
    );
    netProfit =
      placeRevenue -
      totalSalaries -
      totalExpensesAmount -
      totalInvoicesCost +
      totalExtraProfit;
  } else if (choosedPlace?.paidWay === 3) {
    placeRevenue = totalGlobalPaymentsReceived;
    netProfit =
      totalGlobalPaymentsReceived -
      allTimeTotalSalaries -
      allTimeExpensesAmount -
      totalInvoicesCost +
      totalExtraProfit;
  } else {
    placeRevenue = parseFloat(choosedPlace?.profit || 0);
    netProfit =
      placeRevenue -
      totalSalaries -
      totalExpensesAmount -
      totalInvoicesCost +
      totalExtraProfit;
  }

  /* ── Calendar ── */
  const getAllDaysInMonth = () => {
    if (!choosedMonth) return [];
    const [month, year] = choosedMonth.split("-");
    const days = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();
    return Array.from(
      { length: days },
      (_, i) => `${String(i + 1).padStart(2, "0")}-${month}-${year}`,
    );
  };
  const groupByDate = () =>
    filteredDailyWork.reduce((g, item) => {
      if (!g[item.date]) g[item.date] = [];
      g[item.date].push(item);
      return g;
    }, {});
  const allDays = getAllDaysInMonth();
  const groupedData = groupByDate();

  const getDayTotal = (date) =>
    (groupedData[date] || []).reduce(
      (s, i) => s + (parseFloat(i.salary) || 0),
      0,
    );
  const getDayRevenue = (date) =>
    (groupedData[date] || []).reduce(
      (s, i) => s + (parseFloat(i.placeDailySalary) || 0),
      0,
    );
  const hasNotes = (date) =>
    (groupedData[date] || []).some((i) => i.note?.trim());

  const workingDays = Object.keys(groupedData).length;
  const uniqueEmployees = new Set(filteredDailyWork.map((i) => i.employeeId))
    .size;

  const getEmployeeName = (id) =>
    (allData.myEmployees || []).find((e) => e.id === id)?.name ||
    `Employee ${id}`;
  const getManagerName = (id) =>
    (allData.myEmployees || []).find((e) => e.id === id)?.name || "Me";

  const handleDayClick = (date) => {
    const dayData = groupedData[date] || [];
    setSelectedDate(date);
    setExistingEmployees(
      dayData.map((item) => {
        const emp = (allData.myEmployees || []).find(
          (e) => e.id === item.employeeId,
        );
        return {
          id: item.employeeId,
          name: emp?.name || `Employee ${item.employeeId}`,
          salary: item.salary.toString(),
        };
      }),
    );
    setShowCreateModal(true);
  };

  const showConfirm = (message) =>
    new Promise((resolve) => setConfirmDialog({ visible: true, message, onConfirm: resolve }));

  const showToast = (message, type = "success") => {
    setToast({ visible: true, message, type });
    setTimeout(() => setToast({ visible: false, message: "", type: "success" }), 3000);
  };

  const handleDeleteExpense = async (expense) => {
    const confirmed = await showConfirm(`Delete expense "${expense.title}"?`);
    if (!confirmed) return;
    try {
      await axios.delete(`${MyDomain}Expenses/DeleteExpense`, {
        data: { Id: expense.id },
      });
      fetchAllData();
    } catch {
      showToast("Failed to delete expense", "error");
    }
  };
  const handleDeleteMonthlySalary = async (ms, empName) => {
    const confirmed = await showConfirm(`Delete monthly salary for ${empName}?`);
    if (!confirmed) return;
    try {
      await axios.delete(`${MyDomain}MonthlySalary/DeleteMonthlySalary`, {
        data: { Id: ms.id },
      });
      fetchAllData();
    } catch {
      showToast("Failed to delete monthly salary", "error");
    }
  };
  const handleDeleteGlobalPayment = async (payment) => {
    const amt = `₪${parseFloat(payment.profit).toLocaleString()}`;
    const dt = moment(payment.dateGetPaid, "DD-MM-YYYY").format("MMM DD, YYYY");
    const confirmed = await showConfirm(`Delete payment ${amt} from ${dt}?`);
    if (!confirmed) return;
    try {
      await axios.delete(
        `${MyDomain}PlacesGloballyPaid/DeletePlacesGloballyPaid`,
        { data: { Id: payment.id } },
      );
      fetchAllData();
    } catch {
      showToast("Failed to delete payment", "error");
    }
  };
  const handleDeleteExtraProfit = async (ep) => {
    const amt = `₪${parseFloat(ep.profit).toLocaleString()}`;
    const dt = moment(ep.date, "DD-MM-YYYY").format("MMM DD, YYYY");
    const confirmed = await showConfirm(`Delete extra profit ${amt} from ${dt}?`);
    if (!confirmed) return;
    try {
      await axios.delete(`${MyDomain}PlaceExtraProfit/DeletePlaceExtraProfit`, {
        data: { Id: ep.id },
      });
      fetchAllData();
    } catch {
      showToast("Failed to delete extra profit", "error");
    }
  };

  const showFinancialBreakdown =
    placeRevenue > 0 ||
    choosedPlace?.paidWay === 3 ||
    placeInvoices.length > 0 ||
    totalExpensesAmount > 0 ||
    totalSalaries > 0;
  const totalCosts =
    choosedPlace?.paidWay === 3
      ? allTimeTotalSalaries + allTimeExpensesAmount + totalInvoicesCost
      : totalSalaries + totalExpensesAmount + totalInvoicesCost;

  const paidWayLabel = {
    1: "Monthly Profit",
    2: "Total Revenue",
    3: "Global Profit",
  };

  // Currency symbol helper
  const currencySymbol = { ILS: "₪", USD: "$", EUR: "€", GBP: "£" };

  return (
    <div className="spd">
      <style>{STYLES}</style>

      {/* Header */}
      <header className="spd-header">
        <div className="spd-topbar">
          <button className="spd-back" onClick={() => history.goBack()}>
            <ChevronLeft size={18} />
          </button>
          <div className="spd-place-ico">
            <MapPin size={20} color="#fff" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p className="spd-place-name">{choosedPlace?.place}</p>
            <p className="spd-place-sub">{t("placePerformance")}</p>
          </div>
        </div>

        {/* 5-button actions */}
        <div className="spd-actions">
          <button
            className="spd-action edit"
            onClick={() => setShowUpdatePlaceModal(true)}
          >
            <Edit2 size={15} color="#fff" />
            <span>{t("edit")}</span>
          </button>
          <button
            className="spd-action salary"
            onClick={() => setShowMonthlySalaryModal(true)}
          >
            <Wallet size={15} color="#fff" />
            <span>{t("salary")}</span>
          </button>
          <button
            className="spd-action expense"
            onClick={() => setShowCreateExpenseModal(true)}
          >
            <Receipt size={15} color="#fff" />
            <span>{t("expense")}</span>
          </button>
          <button
            className="spd-action invoice"
            onClick={() => setCreateInvoiceVisible(true)}
          >
            <FileText size={15} color="#fff" />
            <span>{t("newInvoice")}</span>
          </button>
          <button
            className="spd-action invoices"
            onClick={() => setShowPlaceInvoicesModal(true)}
          >
            <FileText size={15} color="#fff" />
            <span>{t("invoices")}</span>
            <span
              style={{
                position: "absolute",
                top: -4,
                right: -4,
                background: "#dc2626",
                color: "#fff",
                fontSize: 8,
                fontWeight: 700,
                borderRadius: "50%",
                width: 14,
                height: 14,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {placeInvoices.length}
            </span>
          </button>
        </div>
      </header>

      <div className="spd-body">
        {/* Month scroller */}
        <div className="spd-month-section">
          <p className="spd-sec-title">{t("selectMonth")}</p>
          <div className="spd-month-row">
            <button
              className="spd-month-arrow"
              onClick={() => scrollMonths(-1)}
            >
              <ChevronLeft size={14} />
            </button>
            <div className="spd-month-scroll-wrap">
              <div className="spd-month-track" ref={monthTrackRef}>
                {monthList.map((item) => {
                  const [, year] = item.split("-");
                  return (
                    <button
                      key={item}
                      className={`spd-month-btn${choosedMonth === item ? " active" : ""}`}
                      onClick={() => setChoosedMonth(item)}
                    >
                      <span className="spd-month-name">
                        {moment(item, "MM-YYYY").format("MMM")}
                      </span>
                      <span className="spd-month-year">{year}</span>
                    </button>
                  );
                })}
              </div>
            </div>
            <button className="spd-month-arrow" onClick={() => scrollMonths(1)}>
              <ChevronRight size={14} />
            </button>
          </div>
        </div>

        {/* Quick stats */}
        <div className="spd-stats">
          <div className="spd-stat blue">
            <div className="spd-stat-ico">
              <Calendar size={16} color="#3B82F6" />
            </div>
            <div>
              <div className="spd-stat-val">{workingDays}</div>
              <div className="spd-stat-lbl">{t("workingDays")}</div>
            </div>
          </div>
          <div className="spd-stat purple">
            <div className="spd-stat-ico">
              <Users size={16} color="#7C3AED" />
            </div>
            <div>
              <div className="spd-stat-val">{uniqueEmployees}</div>
              <div className="spd-stat-lbl">{t("employees")}</div>
            </div>
          </div>
        </div>

        {/* Financial Breakdown */}
        {showFinancialBreakdown && (
          <div style={{ marginBottom: 16 }}>
            <div className="spd-finance-header">
              <p className="spd-sec-title" style={{ marginBottom: 0 }}>
                {t("financialBreakdown")}
              </p>
              <span className="spd-finance-badge">
                ₪{totalCosts.toLocaleString()} costs
              </span>
            </div>

            <div className="spd-pair">
              {/* Revenue */}
              {(placeRevenue > 0 || choosedPlace?.paidWay === 3) && (
                <div className="spd-fcard">
                  <div className="spd-fcard-row">
                    <div
                      className="spd-fcard-ico"
                      style={{ background: "#D1FAE5" }}
                    >
                      <TrendingUp size={16} color="#059669" />
                    </div>
                    <div style={{ flex: 1 }}>
                      <p className="spd-fcard-label">
                        {paidWayLabel[choosedPlace?.paidWay] || "Profit"}
                      </p>
                      <p className="spd-fcard-sub">
                        {choosedPlace?.paidWay === 2
                          ? "Daily revenue collected"
                          : choosedPlace?.paidWay === 3
                            ? "Received from global profit"
                            : "Monthly place profit"}
                      </p>
                    </div>
                    <span
                      className="spd-fcard-amount"
                      style={{ color: "#059669" }}
                    >
                      {choosedPlace?.paidWay === 3
                        ? `₪${totalGlobalPaymentsReceived.toLocaleString()} / ₪${totalGlobalProfit.toLocaleString()}`
                        : `₪${placeRevenue.toLocaleString()}`}
                    </span>
                  </div>

                  {choosedPlace?.paidWay === 3 && (
                    <>
                      <div className="spd-fcard-divider" />
                      <div className="spd-list-header">
                        <span className="spd-list-lbl">
                          {t("paymentsReceived")}
                        </span>
                        <button
                          className="spd-add-btn"
                          onClick={() => setShowGlobalPaymentModal(true)}
                        >
                          <PlusCircle size={11} /> {t("addPayment")}
                        </button>
                      </div>
                      {globalPayments.length === 0 ? (
                        <div className="spd-empty-list">
                          <Wallet size={20} color="#D1D5DB" />
                          <p>{t("noData")}</p>
                        </div>
                      ) : (
                        globalPayments.map((payment) => (
                          <div key={payment.id} className="spd-list-item">
                            <div className="spd-list-item-inner">
                              <div className="spd-list-item-left">
                                <div
                                  className="spd-list-item-ico"
                                  style={{ background: "#D1FAE5" }}
                                >
                                  <DollarSign size={12} color="#059669" />
                                </div>
                                <div>
                                  <p className="spd-list-item-title">
                                    {moment(
                                      payment.dateGetPaid,
                                      "DD-MM-YYYY",
                                    ).format("MMM DD, YYYY")}
                                  </p>
                                </div>
                              </div>
                              <span
                                className="spd-list-item-amt"
                                style={{ color: "#059669" }}
                              >
                                ₪{parseFloat(payment.profit).toLocaleString()}
                              </span>
                            </div>
                            <button
                              className="spd-del-btn"
                              onClick={() => handleDeleteGlobalPayment(payment)}
                            >
                              <Trash2 size={13} color="#EF4444" />
                            </button>
                          </div>
                        ))
                      )}
                    </>
                  )}
                </div>
              )}

              {/* Extra profit */}
              <div className="spd-fcard">
                <div className="spd-fcard-row">
                  <div
                    className="spd-fcard-ico"
                    style={{ background: "#D1FAE5" }}
                  >
                    <Gift size={16} color="#059669" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="spd-fcard-label">{t("extraProfit")}</p>
                    <p className="spd-fcard-sub">Additional work income</p>
                  </div>
                  <span
                    className="spd-fcard-amount"
                    style={{ color: "#059669" }}
                  >
                    ₪{totalExtraProfit.toLocaleString()}
                  </span>
                </div>
                <div className="spd-fcard-divider" />
                <div className="spd-list-header">
                  <span className="spd-list-lbl">{t("extraProfit")}</span>
                  <button
                    className="spd-add-btn"
                    onClick={() => setShowExtraProfitModal(true)}
                  >
                    <PlusCircle size={11} /> {t("addExtra")}
                  </button>
                </div>
                {filteredExtraProfits.length === 0 ? (
                  <div className="spd-empty-list">
                    <Gift size={20} color="#D1D5DB" />
                    <p>{t("noData")}</p>
                  </div>
                ) : (
                  filteredExtraProfits.map((ep) => (
                    <div key={ep.id} className="spd-list-item">
                      <div className="spd-list-item-inner">
                        <div className="spd-list-item-left">
                          <div
                            className="spd-list-item-ico"
                            style={{ background: "#D1FAE5" }}
                          >
                            <Gift size={12} color="#059669" />
                          </div>
                          <div>
                            <p className="spd-list-item-title">
                              {moment(ep.date, "DD-MM-YYYY").format(
                                "MMM DD, YYYY",
                              )}
                            </p>
                            {ep.note?.trim() && (
                              <p
                                className="spd-list-item-sub"
                                style={{ fontStyle: "italic" }}
                              >
                                {ep.note}
                              </p>
                            )}
                          </div>
                        </div>
                        <span
                          className="spd-list-item-amt"
                          style={{ color: "#059669" }}
                        >
                          ₪{parseFloat(ep.profit).toLocaleString()}
                        </span>
                      </div>
                      <button
                        className="spd-del-btn"
                        onClick={() => handleDeleteExtraProfit(ep)}
                      >
                        <Trash2 size={13} color="#EF4444" />
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* Daily salaries */}
            {totalDailySalaries > 0 && (
              <div className="spd-fcard">
                <div className="spd-fcard-row">
                  <div
                    className="spd-fcard-ico"
                    style={{ background: "#FEE2E2" }}
                  >
                    <Calendar size={16} color="#DC2626" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="spd-fcard-label">{t("dailySalaries")}</p>
                    <p className="spd-fcard-sub">Paid to daily employees</p>
                  </div>
                  <span
                    className="spd-fcard-amount"
                    style={{ color: "#DC2626" }}
                  >
                    ₪{totalDailySalaries.toLocaleString()}
                  </span>
                </div>
              </div>
            )}

            {/* Monthly salaries */}
            {totalMonthlySalaries > 0 && (
              <div className="spd-fcard">
                <div className="spd-fcard-row">
                  <div
                    className="spd-fcard-ico"
                    style={{ background: "#EDE9FE" }}
                  >
                    <Wallet size={16} color="#7C3AED" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="spd-fcard-label">{t("monthlyEmployees")}</p>
                    <p className="spd-fcard-sub">Fixed monthly salaries</p>
                  </div>
                  <span
                    className="spd-fcard-amount"
                    style={{ color: "#7C3AED" }}
                  >
                    ₪{totalMonthlySalaries.toLocaleString()}
                  </span>
                </div>
                <div className="spd-fcard-divider" />
                {filteredMonthlySalaries.map((item) => {
                  const emp = (allData.myEmployees || []).find(
                    (e) => e.id === item.employeeId,
                  );
                  if (!emp) return null;
                  return (
                    <div key={item.id} className="spd-list-item">
                      <div className="spd-list-item-inner">
                        <div className="spd-list-item-left">
                          <div
                            className="spd-list-item-ico"
                            style={{ background: "#EDE9FE" }}
                          >
                            <Users size={12} color="#7C3AED" />
                          </div>
                          <div>
                            <p className="spd-list-item-title">{emp.name}</p>
                            <p className="spd-list-item-sub">
                              Paid:{" "}
                              {moment(item.date, "DD-MM-YYYY").format("MMM DD")}
                            </p>
                          </div>
                        </div>
                        <span
                          className="spd-list-item-amt"
                          style={{ color: "#7C3AED" }}
                        >
                          ₪{emp.monthlySalary?.toLocaleString() || 0}
                        </span>
                      </div>
                      <button
                        className="spd-del-btn"
                        onClick={() =>
                          handleDeleteMonthlySalary(item, emp.name)
                        }
                      >
                        <Trash2 size={13} color="#EF4444" />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Expenses */}
            {totalExpensesAmount > 0 && (
              <div className="spd-fcard">
                <div className="spd-fcard-row">
                  <div
                    className="spd-fcard-ico"
                    style={{ background: "#FEF3C7" }}
                  >
                    <Receipt size={16} color="#D97706" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="spd-fcard-label">{t("totalExpenses")}</p>
                    <p className="spd-fcard-sub">
                      {filteredExpenses.length} items this month
                    </p>
                  </div>
                  <span
                    className="spd-fcard-amount"
                    style={{ color: "#D97706" }}
                  >
                    ₪{totalExpensesAmount.toLocaleString()}
                  </span>
                </div>
                <div className="spd-fcard-divider" />
                {expenseTypes.map((type) => {
                  const typeExp = filteredExpenses.filter(
                    (e) => e.type === type.id,
                  );
                  const typeTotal = typeExp.reduce(
                    (s, e) => s + (parseFloat(e.price) || 0),
                    0,
                  );
                  if (typeTotal === 0) return null;
                  return (
                    <div key={type.id} className="spd-exp-type-row">
                      <div className="spd-exp-type-left">
                        <div
                          className="spd-exp-type-ico"
                          style={{ background: type.color + "20" }}
                        >
                          <Receipt size={12} color={type.color} />
                        </div>
                        <span
                          style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#374151",
                          }}
                        >
                          {type.name}
                        </span>
                        <span className="spd-exp-badge">{typeExp.length}</span>
                      </div>
                      <span
                        style={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: type.color,
                          fontFamily: "'JetBrains Mono',monospace",
                        }}
                      >
                        ₪{typeTotal.toLocaleString()}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}

            {/* ── Invoice costs card — always visible ── */}
            <div className="spd-fcard">
              <div className="spd-fcard-row">
                <div
                  className="spd-fcard-ico"
                  style={{ background: "#EDE9FE" }}
                >
                  <FileText size={16} color="#7C3AED" />
                </div>
                <div style={{ flex: 1 }}>
                  <p className="spd-fcard-label">{t("invoiceCosts")}</p>
                  <p className="spd-fcard-sub">
                    {placeInvoices.length > 0
                      ? `${placeInvoices.length} linked invoice${placeInvoices.length !== 1 ? "s" : ""}`
                      : "No invoices linked yet"}
                  </p>
                </div>
                {totalInvoicesCost > 0 && (
                  <span
                    className="spd-fcard-amount"
                    style={{ color: "#7C3AED" }}
                  >
                    ₪
                    {totalInvoicesCost.toLocaleString("he-IL", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                )}
              </div>
              <div className="spd-fcard-divider" />
              {placeInvoices.length === 0 ? (
                <div className="spd-empty-list">
                  <FileText size={20} color="#D1D5DB" />
                  <p>{t("noInvoicesFound")}</p>
                </div>
              ) : (
                <>
                  {placeInvoices.map((inv) => {
                    const currency = inv.currency || "ILS";
                    const sym = currencySymbol[currency] || currency;
                    const faceValue = parseFloat(inv.price || 0);
                    const ilsVal = inv.ilsEquivalent;
                    const isForeign = currency !== "ILS";
                    const rateAvailable = inv.exchangeRate != null;

                    return (
                      <div
                        key={inv.id}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          fontSize: 11,
                          color: "#6b7280",
                          padding: "8px 0",
                          borderBottom: "1px solid #f9fafb",
                          gap: 8,
                        }}
                      >
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              fontWeight: 600,
                              color: "#374151",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {inv.subject ||
                              inv.whoSend ||
                              inv.description ||
                              "Invoice"}
                          </div>
                          {inv.date && (
                            <div
                              style={{
                                fontSize: 10,
                                color: "#9ca3af",
                                marginTop: 1,
                              }}
                            >
                              {inv.date}
                            </div>
                          )}
                          {/* Show exchange rate info for foreign currency invoices */}
                          {isForeign && (
                            <div
                              style={{
                                fontSize: 9,
                                color: "#7c3aed",
                                marginTop: 2,
                                fontStyle: "italic",
                              }}
                            >
                              {rateAvailable
                                ? `1 ${currency} = ₪${inv.exchangeRate.toFixed(3)} on invoice date`
                                : `Rate unavailable — using face value`}
                            </div>
                          )}
                        </div>
                        <div style={{ textAlign: "right", flexShrink: 0 }}>
                          {/* Original amount */}
                          <div
                            style={{
                              fontWeight: 700,
                              color: "#7c3aed",
                              fontFamily: "monospace",
                            }}
                          >
                            {sym}
                            {faceValue.toLocaleString("he-IL", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                            {isForeign && (
                              <span
                                style={{
                                  fontSize: 9,
                                  marginLeft: 3,
                                  color: "#9ca3af",
                                }}
                              >
                                {currency}
                              </span>
                            )}
                          </div>
                          {/* ILS equivalent for foreign invoices */}
                          {isForeign && ilsVal != null && (
                            <div
                              style={{
                                fontSize: 10,
                                color: "#6d28d9",
                                fontFamily: "monospace",
                                marginTop: 2,
                              }}
                            >
                              ≈ ₪
                              {ilsVal.toLocaleString("he-IL", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          )}
                          {isForeign && ilsVal == null && (
                            <div
                              style={{
                                fontSize: 9,
                                color: "#f59e0b",
                                marginTop: 2,
                              }}
                            >
                              (rate lookup failed)
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}

                  {/* Total ILS equivalent summary line */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 8,
                      paddingTop: 8,
                      borderTop: "1.5px solid #ede9fe",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: "#6d28d9",
                      }}
                    >
                      Total (ILS equivalent)
                    </span>
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        color: "#7c3aed",
                        fontFamily: "monospace",
                      }}
                    >
                      ₪
                      {totalInvoicesCost.toLocaleString("he-IL", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                </>
              )}
              <button
                onClick={() => setShowPlaceInvoicesModal(true)}
                style={{
                  width: "100%",
                  marginTop: 10,
                  padding: "8px",
                  background: "#ede9fe",
                  border: "none",
                  borderRadius: 8,
                  color: "#7c3aed",
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                {placeInvoices.length > 0
                  ? "Manage Invoices →"
                  : "+ Link Invoices"}
              </button>
            </div>

            {/* Net Profit */}
            <div
              className={`spd-net-card ${netProfit >= 0 ? "positive" : "negative"}`}
            >
              <div className="spd-fcard-row">
                <div
                  className="spd-fcard-ico"
                  style={{ background: netProfit >= 0 ? "#D1FAE5" : "#FEE2E2" }}
                >
                  {netProfit >= 0 ? (
                    <TrendingUp size={16} color="#059669" />
                  ) : (
                    <TrendingDown size={16} color="#DC2626" />
                  )}
                </div>
                <div style={{ flex: 1 }}>
                  <p className="spd-fcard-label">{t("netProfit")}</p>
                  <p className="spd-fcard-sub">
                    {choosedPlace?.paidWay === 2
                      ? "Revenue minus costs"
                      : choosedPlace?.paidWay === 3
                        ? "Received minus all costs"
                        : "Profit minus costs"}
                  </p>
                </div>
                <span
                  style={{
                    fontFamily: "'JetBrains Mono',monospace",
                    fontSize: 17,
                    fontWeight: 800,
                    color: netProfit >= 0 ? "#059669" : "#DC2626",
                  }}
                >
                  ₪{netProfit.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Daily Operations */}
        <div>
          <div className="spd-days-header">
            <p className="spd-sec-title" style={{ marginBottom: 0 }}>
              {t("dailyOperations")}
            </p>
            <span className="spd-days-badge">{allDays.length} days</span>
          </div>

          {allDays.length === 0 ? (
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                padding: "32px 20px",
                textAlign: "center",
                border: "1px solid #E5E7EB",
              }}
            >
              <Calendar
                size={32}
                color="#D1D5DB"
                style={{ margin: "0 auto 10px" }}
              />
              <p style={{ fontSize: 14, fontWeight: 600, color: "#9CA3AF" }}>
                {t("noDataThisMonth")}
              </p>
            </div>
          ) : (
            <div className="spd-day-grid">
              {allDays.map((date) => {
                const dayData = groupedData[date] || [];
                const hasWork = dayData.length > 0;
                const hasNote = hasNotes(date);
                const isToday = moment(date, "DD-MM-YYYY").isSame(
                  moment(),
                  "day",
                );
                const dayNum = moment(date, "DD-MM-YYYY").format("DD");
                const dayName = moment(date, "DD-MM-YYYY").format("ddd");
                return (
                  <button
                    key={date}
                    className={`spd-day${hasWork ? " worked" : ""}${isToday ? " today" : ""}`}
                    onClick={() => handleDayClick(date)}
                  >
                    {hasNote && (
                      <div className="spd-day-note-dot">
                        <FileText size={8} color="#D97706" />
                      </div>
                    )}
                    <div className="spd-day-top">
                      <span className="spd-day-num">{dayNum}</span>
                      <span className="spd-day-name">{dayName}</span>
                    </div>
                    <div className="spd-day-body">
                      {hasWork ? (
                        <>
                          <div className="spd-day-badges">
                            <span className="spd-badge emp">
                              <Users size={8} /> {dayData.length}
                            </span>
                            {choosedPlace?.paidWay === 2 ? (
                              <span className="spd-badge rev">
                                <TrendingUp size={8} />₪
                                {getDayRevenue(date).toFixed(0)}
                              </span>
                            ) : (
                              <span className="spd-badge salary">
                                <DollarSign size={8} />₪
                                {getDayTotal(date).toFixed(0)}
                              </span>
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 3,
                            }}
                          >
                            {dayData.map((item) => (
                              <div key={item.id} className="spd-day-emp">
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <p className="spd-day-emp-name">
                                    {getEmployeeName(item.employeeId)}
                                  </p>
                                  <p className="spd-day-emp-sal">
                                    ₪{item.salary}
                                  </p>
                                  {choosedPlace?.paidWay === 2 &&
                                    item.placeDailySalary && (
                                      <p className="spd-day-emp-rev">
                                        Rev: ₪{item.placeDailySalary}
                                      </p>
                                    )}
                                  {item.whoMake && (
                                    <p className="spd-day-emp-mgr">
                                      by {getManagerName(item.whoMake)}
                                    </p>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        <div className="spd-day-empty">
                          <PlusCircle size={20} color="#D1D5DB" />
                          <span
                            style={{
                              fontSize: 9,
                              color: "#9CA3AF",
                              fontWeight: 600,
                            }}
                          >
                            {t("noActivity")}
                          </span>
                          <span style={{ fontSize: 8, color: "#D1D5DB" }}>
                            Tap to add
                          </span>
                        </div>
                      )}
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Modals */}
      <BossCreateDayWork
        visible={showCreateModal}
        onClose={() => {
          setShowCreateModal(false);
          setExistingEmployees([]);
        }}
        onSuccess={() => {
          setShowCreateModal(false);
          setExistingEmployees([]);
          fetchAllData();
        }}
        places={allData.myPlaces}
        employees={allData.myEmployees}
        preselectedDate={selectedDate}
        preselectedPlaceId={choosedPlace?.id}
        preselectedEmployees={existingEmployees}
      />
      <BossCreateExpenses
        visible={showCreateExpenseModal}
        onClose={() => setShowCreateExpenseModal(false)}
        onSuccess={() => {
          setShowCreateExpenseModal(false);
          fetchAllData();
        }}
        preselectedPlaceId={choosedPlace?.id}
      />
      <BossUpdateExpensesModal
        visible={showUpdateExpenseModal}
        onClose={() => setShowUpdateExpenseModal(false)}
        expense={selectedExpense}
        onUpdateSuccess={() => {
          setShowUpdateExpenseModal(false);
          fetchAllData();
        }}
      />
      <BossUpdateEmployeeModal
        visible={showUpdateEmployeeModal}
        onClose={() => setShowUpdateEmployeeModal(false)}
        employee={selectedEmployee}
        onUpdateSuccess={() => {
          setShowUpdateEmployeeModal(false);
          fetchAllData();
        }}
      />
      <BossUpdatePlacesModal
        visible={showUpdatePlaceModal}
        onClose={() => setShowUpdatePlaceModal(false)}
        place={choosedPlace}
        onUpdateSuccess={async () => {
          setShowUpdatePlaceModal(false);
          await fetchAllData();
        }}
      />
      <BossCreateMonthlySalary
        visible={showMonthlySalaryModal}
        onClose={() => setShowMonthlySalaryModal(false)}
        onSuccess={() => {
          setShowMonthlySalaryModal(false);
          fetchAllData();
        }}
        placeId={choosedPlace?.id}
        placeName={choosedPlace?.place}
      />
      <BossCreatePlacesGloballyPaidModal
        visible={showGlobalPaymentModal}
        onClose={() => setShowGlobalPaymentModal(false)}
        onSuccess={() => {
          setShowGlobalPaymentModal(false);
          fetchAllData();
        }}
        placeId={choosedPlace?.id}
        placeName={choosedPlace?.place}
      />
      <BossStatisticPlacesModalAddExtraProfit
        visible={showExtraProfitModal}
        onClose={() => setShowExtraProfitModal(false)}
        onSuccess={() => {
          setShowExtraProfitModal(false);
          fetchAllData();
        }}
        placeId={choosedPlace?.id}
        placeName={choosedPlace?.place}
      />
      <BossCreateInvoice
        visible={createInvoiceVisible}
        onClose={() => setCreateInvoiceVisible(false)}
        onSuccess={() => {
          setCreateInvoiceVisible(false);
          fetchAllData();
          loadPlaceInvoices();
        }}
        preselectedPlaceId={choosedPlace?.id}
      />
      <BossPlaceInvoicesModal
        visible={showPlaceInvoicesModal}
        onClose={() => setShowPlaceInvoicesModal(false)}
        placeId={choosedPlace?.id}
        placeName={choosedPlace?.place}
        onInvoicesChange={() => loadPlaceInvoices()}
      />

      {/* Confirm Dialog */}
      {confirmDialog.visible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-6">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm shadow-2xl">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                <Trash2 className="w-5 h-5 text-red-600" />
              </div>
              <p className="text-gray-800 font-medium leading-snug">
                {confirmDialog.message}
              </p>
            </div>
            <div className="flex gap-3">
              <button
                className="flex-1 py-2.5 rounded-xl border border-gray-200 text-gray-700 font-semibold text-sm"
                onClick={() => {
                  confirmDialog.onConfirm(false);
                  setConfirmDialog({ visible: false, message: "", onConfirm: null });
                }}
              >
                Cancel
              </button>
              <button
                className="flex-1 py-2.5 rounded-xl bg-red-600 text-white font-semibold text-sm"
                onClick={() => {
                  confirmDialog.onConfirm(true);
                  setConfirmDialog({ visible: false, message: "", onConfirm: null });
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {toast.visible && (
        <div
          className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-5 py-3 rounded-xl shadow-lg text-white text-sm font-semibold ${
            toast.type === "error" ? "bg-red-600" : "bg-green-600"
          }`}
        >
          {toast.message}
        </div>
      )}
    </div>
  );
}
